/**
 * Copy for the `?error=` reasons the server's BFF redirects to /login with (apps/server
 * routes/adminAuth.ts `failTo`). Unknown reasons fall back to the code itself.
 */
export const LOGIN_ERROR_TEXT: Record<string, string> = {
  user_not_invited: 'This identity is not an invited Agency user. Ask an administrator for an invitation.',
  user_suspended: 'This account is suspended. Ask an administrator to reactivate it.',
  state_invalid: 'The sign-in attempt expired or was already used. Start again.',
  idp_error: 'The identity provider rejected the sign-in.',
  token_invalid: 'The identity provider returned an invalid token. Start again.',
  invitation_invalid: 'This invitation link is not valid. Ask an administrator to resend it.',
  invitation_expired: 'This invitation has expired. Ask an administrator to resend it.',
  invitation_accepted: 'This invitation was already accepted. Sign in with your workforce identity.',
  invitation_cancelled: 'This invitation was cancelled. Ask an administrator for a new one.',
  identity_mismatch: 'The identity you signed in with does not match the invited address. Sign in with the invited identity.',
};

export function loginErrorText(code: string | undefined | null): string | undefined {
  if (!code) return undefined;
  return LOGIN_ERROR_TEXT[code] ?? `Sign-in failed (${code}).`;
}
